window._define('constants', {
    EVENT: {
        FLASHMESSAGE: 'FlashMessage',
        RESPONSIVE_BREAKPOINT_CHANGE: 'ResponsiveBreakpointChange',
        DOWNLOAD_PDF: 'Download.Pdf',
        VIEW_COURSE: 'View.Course',
        VIEW_PART: 'View.Part',
        RESTRICTED_PAGE_VIEW: 'Restricted Page View',

        LOG: 'Log',

        FILLED_FORM_START: 'Filled Form Started',

        VIEWED_REFERRAL_CODE: 'Viewed Referral Code',
        COPIED_REFERRAL_CODE: 'Copied Referral Code',
        VIEWED_ELEMENT: 'Viewed Element',

        SEGMENTIO_VIEWED_PRODUCT_CATEGORY2: 'Viewed Product Category #2',
        STOPPED_VIDEO: 'Stopped Video',
        STARTED_VIDEO: 'Started Video',
        DOWNLOADED_SINGLE_VIDEO: 'Downloaded Single Video',
        WANTED_TO_CONTACT_US: 'Wanted to Contact Us',
    },
});
